<template>
    <div class="webcam-photo">
        <div v-if="hasCamera">
            <div class="row form-horizontal">
                <label class="control-label col-md-2">{{ t.webcam }}</label>
                <div class="col-md-6">
                    <select v-model="source" class="form-control" @change="start">
                        <option v-for="option in sourceOptions" :key="option.value" :value="option.value">{{ option.text }}</option>
                    </select>
                </div>
            </div>
            <template v-if="!showOutput && source">
                <video autoplay ref="videoElement"></video>
                <button class="btn btn-success btn-large" @click.prevent="takePicture">{{ t.take_photo }}</button>
            </template>
            <canvas v-if="showCanvas" ref="canvasElement" :style="{width: `${width}px`, height: `${height}px`}"></canvas>
            <div v-if="showOutput">
                <img :src="photo">
                <button class="btn btn-default btn-large" @click.prevent="retakePicture">{{ t.retake }}</button>
                <button class="btn btn-success btn-large" @click.prevent="upload">{{ t.add_to_uploader }}</button>
            </div>
        </div>
        <p v-if="!hasCamera">{{ t.no_cam }}</p>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'WebcamPhoto',
    computed: {
        ...mapState({
            t: state => state.t.webcam
        }),
        hasCamera() {
            return this.sourceOptions.length;
        }
    },
    data() {
        return {
            source: null,
            sourceOptions: [],
            showCanvas: false,
            showOutput: false,
            stream: null,
            streaming: false,
            height: 0,
            photo: '',
            width: 1000
        };
    },
    methods: {
        gotDevices(deviceInfos) {
            for (let i = 0; i !== deviceInfos.length; ++i) {
                const deviceInfo = deviceInfos[i];
                if (deviceInfo.kind === 'videoinput') {
                    let exists = false;
                    this.sourceOptions.forEach((option) => {
                        if (option.value === deviceInfo.deviceId) {
                            exists = true;
                        }
                    });
                    if (!exists) {
                        this.sourceOptions.push({
                            text: deviceInfo.label || this.t.camera_num.replace('%counter', this.sourceOptions.length + 1),
                            value: deviceInfo.deviceId
                        });
                    }
                }
            }
        },
        start() {
            this.$nextTick(() => {
                const canPlay = () => {
                    if (!this.streaming) {
                        this.height = this.$refs.videoElement.videoHeight / (this.$refs.videoElement.videoWidth / this.width);
                        this.streaming = true;
                    }
                };
                this.$refs.videoElement.addEventListener('canplay', canPlay.bind(this), false);

                this.stop();

                navigator.mediaDevices.getUserMedia({
                    video: { deviceId: this.source ? { exact: this.source } : undefined }
                }).then((stream) => {
                    this.stream = stream;
                    this.$refs.videoElement.srcObject = stream;
                    // Refresh button list in case labels have become available
                    return navigator.mediaDevices.enumerateDevices();
                }).then(this.gotDevices.bind(this));
            });
        },
        stop() {
            if (this.stream) {
                this.stream.getTracks().forEach((track) => {
                    track.stop();
                });
            }
        },
        retakePicture() {
            this.showOutput = false;
            this.start();
        },
        takePicture() {
            if (this.width && this.height) {
                this.showCanvas = true;
                this.$nextTick(() => {
                    this.$refs.canvasElement.width = this.width;
                    this.$refs.canvasElement.height = this.height;
                    this.$refs.canvasElement.getContext('2d').drawImage(this.$refs.videoElement, 0, 0, this.width, this.height);
                    this.photo = this.$refs.canvasElement.toDataURL('image/png');
                    this.showCanvas = false;
                    this.showOutput = true;
                    this.stop();
                });
            } else {
                this.retakePicture();
            }
        },
        upload() {
            const blobBin = atob(this.photo.split(',')[1]);
            const array = [];
            for (let i = 0; i < blobBin.length; i++) {
                array.push(blobBin.charCodeAt(i));
            }

            const file = new Blob([new Uint8Array(array)], { type: 'image/png' });
            file.name = 'mywebcam.png';
            this.$emit('upload', file);
        }
    },
    mounted() {
        navigator.mediaDevices.enumerateDevices()
            .then(this.gotDevices.bind(this));
    }
};

</script>

<style lang="scss">
.webcam-photo {
    min-height: 100px;
    text-align: center;
    .form-horizontal {
        margin-bottom: 10px;
    }
    video, img {
        width: 100%;
        height: 100%;
    }
    .btn {
        margin-top: -130px;
        position: relative;
    }
}
</style>
